import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { ForgetPasswordWithTokenAPIRoute } from "@/services/auth/forgetPassword";
import { TextError } from "../Helpers/InputContainer";
import { toast } from "react-hot-toast";
import {
  changePasswordInitialValues,
  changePasswordValidationSchema,
} from "@/constants/Auth";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import { useTurnstile } from "react-turnstile";
import TurnstileRecaptcha from "../turnstile/TurnstileRecaptcha";

function ChangePassword({ Context, state, setState }) {
  const {
    t,
    i18n: { language: lang },
  } = useTranslation("common");
  const turnstile = useTurnstile();

  const [show, setShow] = useState(false);
  const handleSubmit = async (values, { setSubmitting, setFieldValue }) => {
    const changedPassword = await ForgetPasswordWithTokenAPIRoute({
      email: state.email,
      resetToken: state.otp,
      newPassword: values.newPassword,
      confirmPassword: values.confirmPassword,
      recaptchaToken: values.token,
    });

    if (changedPassword?.data?.data == true) {
      toast.success(t("PasswordUpdatedSuccessfully"));
      setSubmitting(false);
      Context?.dispatch({ type: "forgotModal" });
      Context?.dispatch({ type: "authModal" });
    } else {
      turnstile.reset();
      setFieldValue("token", "");
      toast.error(t("Invalid OTP."));
      setSubmitting(false);
      setState((prev) => {
        return { ...prev, name: "verification-code" };
      });
    }
  };

  return (
    <section>
      <p className="my-3 text-zinc-600">{t("ForgotPasswordDescription")}</p>
      <Formik
        initialValues={changePasswordInitialValues}
        validationSchema={changePasswordValidationSchema(t)}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form>
            <div className="mb-2">
              <label
                className="block mb-1 font-semibold cursor-pointer"
                htmlFor="new-password"
              >
                {t("AskNewPassword")}
              </label>
              <div className="relative">
                <Field
                  name="newPassword"
                  className="w-full p-2 border rounded-md outline-0"
                  type={!show ? "password" : "text"}
                  placeholder={t("AskNewPassword")}
                  id="new-password"
                />
                {!show ? (
                  <AiOutlineEye
                    size={24}
                    className={`absolute top-1/2 ${
                      lang === "en" ? "right-1" : "left-1"
                    } -translate-y-1/2 text-zinc-500 cursor-pointer`}
                    onClick={() => setShow(!show)}
                  />
                ) : (
                  <AiOutlineEyeInvisible
                    size={24}
                    className={`absolute top-1/2 ${
                      lang === "en" ? "right-1" : "left-1"
                    } -translate-y-1/2 text-zinc-500 cursor-pointer`}
                    onClick={() => setShow(!show)}
                  />
                )}
              </div>
              <ErrorMessage name="newPassword" component={TextError} />
            </div>
            <div className="mb-2">
              <label
                className="block mb-1 font-semibold cursor-pointer"
                htmlFor="rep-password"
              >
                {t("ConfirmPassword")}
              </label>
              <div className="relative">
                <Field
                  name="confirmPassword"
                  className="w-full p-2 border rounded-md outline-0"
                  type={!show ? "password" : "text"}
                  placeholder={t("ConfirmPassword")}
                  id="rep-password"
                />
                {!show ? (
                  <AiOutlineEye
                    size={24}
                    className={`absolute top-1/2 ${
                      lang === "en" ? "right-1" : "left-1"
                    } -translate-y-1/2 text-zinc-500 cursor-pointer`}
                    onClick={() => setShow(!show)}
                  />
                ) : (
                  <AiOutlineEyeInvisible
                    size={24}
                    className={`absolute top-1/2 ${
                      lang === "en" ? "right-1" : "left-1"
                    } -translate-y-1/2 text-zinc-500 cursor-pointer`}
                    onClick={() => setShow(!show)}
                  />
                )}
              </div>
              <ErrorMessage name="confirmPassword" component={TextError} />
            </div>
            <TurnstileRecaptcha
              action='change-password'
              className='flex justify-center items-center p-2'
              onVerify={(value) => {
                setFieldValue('token', value);
              }}
            />
            <button
              disabled={isSubmitting}
              type="submit"
              className="w-full p-2 font-semibold text-white rounded-md disabled:cursor-not-allowed bg-blue campaign:bg-campaignAccent border-red hover:bg-lightred"
            >
              {t(isSubmitting ? "Sending" : "ChangePassword")}
            </button>
          </Form>
        )}
      </Formik>
    </section>
  );
}

export default ChangePassword;
